<template>
  <div>
    <faq-banner :pageObj="faqPage"/>
    <static-faq :searchText="searchText"/>
    <static-footer :pageObj="faqPage"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StaticFooter from '@/components/Footer/StaticFooter'
import StaticFaq from '@/components/StaticPages/StaticFaq'
import FaqBanner from '@/components/StaticPages/components/FaqBanner'

export default {
  name: 'FAQ',
  components: {
    StaticFaq,
    StaticFooter,
    FaqBanner,
  },
  data: () => ({
    searchText: ''
  }),
  computed: {
    ...mapGetters([
      'all_static_pages',
    ]),
    faqPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.slug === 'faq')
      }
      return {}
    },
  },
}
</script>

<style></style>
